import React from 'react'
import {Link} from "react-router-dom";
import { useSelector } from 'react-redux';

const ContactIssueContentList = (props) => {
  const intentSelection = useSelector((state) => state.intent.value);

  const createLink = (kb) => {
    if (kb['link'].includes("/solutions/")) {
      return (<Link to={props.relativeUrl+kb['link']}>{kb['title']}</Link>);
    } else if ( (kb['link'].includes("/sp/")) || (kb['link'].includes("/osp/")) ){
      const kb_link_arr = kb['link'].split("/");
      kb_link_arr[4] = document.location.href.split("/")[4];
      kb_link_arr[5] = document.location.href.split("/")[5];
      const kb_link = kb_link_arr.join("/");
      return (<a href={kb_link} target="_blank">{kb['title']}</a>);
    } else {
      return (<a href={kb['link']} target="_blank">{kb['title']}</a>);
    }
  }

  return (
    <div id="contact-intent-solution-group">
      {(intentSelection && intentSelection !== "other") &&
        <div id="contact-intent-topics">
          <div className="contact-subheader contact-pb-25">{props.contentStrings["review-curated-subheader"]}</div>
          {props.contentSelfHelp[intentSelection]["kb_articles"].map((kb, i) => {
            return (<div className="contact-intent-topic" key={i}>{createLink(kb)}</div>);
          })}
        </div>
      }
    </div>
  )
}
export default ContactIssueContentList